import { storeToRefs } from 'pinia';
import type { Ref } from 'vue';
import { ref } from 'vue';

import useAuthStore from '@/stores/auth.store';

import type { AccountInfo, IPublicClientApplication } from '@azure/msal-browser';
import { InteractionStatus } from '@azure/msal-browser';

export type MsalContext = {
  instance: Ref<IPublicClientApplication>;
  account: Ref<AccountInfo>;
  inProgress: Ref<InteractionStatus>;
};

const mockAccount = {
  homeAccountId: 'homeAccountId',
  environment: 'environment',
  tenantId: 'tenantId',
  username: 'username',
  localAccountId: 'localAccountId',
  name: 'name',
  idToken: 'idToken',
  idTokenClaims: {
    family_name: 'test',
    given_name: 'test',
    email: 'test@gmail.com',
  },
  nativeAccountId: 'string',
};

export function useMsal(): MsalContext {
  const authStore = useAuthStore();
  const { msalInstance, accounts, inProgress } = storeToRefs(authStore);

  if (!msalInstance.value || !accounts.value || !inProgress.value) {
    throw 'Please install the msalPlugin';
  }

  const account = ref(
    import.meta.env.VITE_AUTH_REQUIRED === 'true' ? accounts.value[0] : mockAccount
  );

  if (inProgress.value === InteractionStatus.Startup) {
    msalInstance.value.handleRedirectPromise().catch(() => {
      // Errors should be handled by listening to the LOGIN_FAILURE event
      return;
    });
  }

  return {
    instance: msalInstance,
    account,
    inProgress,
  } as MsalContext;
}
